import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator.ts'
import {
  DashboardClassroomDiagnosticStateSchema,
  type DashboardClassroomDiagnosticStateEntity
} from '@/core/infrastructure/schemas/dashboard/DashboardClassroomDiagnosticStateSchema.ts'

/**
 * État des diagnostics pour une classe
 */
export class DashboardClassroomDiagnosticState {
  readonly schoolClassroomId: number
  readonly hasAssignments: boolean
  readonly isDiagnosticStartExists: boolean
  readonly isDiagnosticEndExists: boolean
  readonly diagStartQuizVersionIds: number[]
  readonly diagEndQuizVersionIds: number[]

  constructor(diagnosticState: DashboardClassroomDiagnosticStateEntity) {
    this.schoolClassroomId = diagnosticState.schoolClassroomId
    this.hasAssignments = diagnosticState.hasAssignments
    this.isDiagnosticStartExists = diagnosticState.isDiagnosticStartExists
    this.isDiagnosticEndExists = diagnosticState.isDiagnosticEndExists
    this.diagStartQuizVersionIds = diagnosticState.diagStartQuizVersionIds
    this.diagEndQuizVersionIds = diagnosticState.diagEndQuizVersionIds
  }

  public static create(data: unknown): DashboardClassroomDiagnosticState {
    return EntityValidator.validateAndCreate(
      DashboardClassroomDiagnosticStateSchema,
      data,
      DashboardClassroomDiagnosticState,
      'DashboardClassroomDiagnosticState'
    )
  }
}
